// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circle {
  background-color: green;
  border-radius: 6px;
  height: 30px;
  text-align: center;
  width: 30px;
  float: left;
  height: 30px;
}

.initials {
  font-size: 14px;
  font-family: Calibri, "Trebuchet MS", sans-serif, "Gill Sans", "Gill Sans MT";
  line-height: 30px;
  color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/initials-avatar/initials-avatar.component.scss"],"names":[],"mappings":"AAEA;EACI,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YATU;AAQd;;AAKA;EACI,eAAA;EACA,6EAAA;EACA,iBAhBU;EAkBV,uBAAA;AAHJ","sourcesContent":["$avatar-size: 30px;\r\n\r\n.circle {\r\n    background-color: green;\r\n    border-radius: 6px;\r\n    height: #{$avatar-size};\r\n    text-align: center;\r\n    width: #{$avatar-size};\r\n    float: left;\r\n    height: $avatar-size;\r\n\r\n}\r\n\r\n.initials {\r\n    font-size: 14px; // 50% of parent \r\n    font-family: Calibri, 'Trebuchet MS', sans-serif, 'Gill Sans', 'Gill Sans MT';\r\n    line-height: $avatar-size;\r\n    \r\n    color: white !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
